import { stringEnum } from '@/models/type-generators/string-enum';

export type MatrixStatusType =
  | 'initialized'
  | 'processing'
  | 'complete'
  | 'completeWithAlerts'
  | 'completeWithRejection'
  | 'uncomplete'
  | 'error';
export const MatrixStatusType = stringEnum<MatrixStatusType>();
